import { isValid, parseISO } from 'date-fns';

import { isFollowUpAudit } from './psmAuditPdf';

const parseSortableTime = value => {
  if (!value) return 0;

  const isoDate = parseISO(value);
  if (isValid(isoDate)) return isoDate.getTime();

  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const pickUploadedAuditDate = item => item?.completedOn || item?.CompletedOn || '';

const pickDigitalAuditDate = item => item?.date || item?.Date || '';

const pickFollowUpAuditDate = item => item?.auditDate || item?.AuditDate || item?.date || item?.Date || '';

export const getRowAuditDate = row => row?.auditDate || '';

const compareRowsByAuditDateDesc = (a, b) => {
  const timeDiff = parseSortableTime(getRowAuditDate(b)) - parseSortableTime(getRowAuditDate(a));
  if (timeDiff !== 0) return timeDiff;
  return (b.id || 0) - (a.id || 0);
};

export const normalizeUploadedPsmAudit = item => ({
  ...item,
  source: 'uploaded',
  name: item.description || '',
  auditor: item.completedBy || '',
  status: 'Completed',
  auditDate: pickUploadedAuditDate(item),
});

export const normalizeDigitalAuditRow = item => ({
  ...item,
  source: 'digital',
  auditDate: pickDigitalAuditDate(item),
});

export const mergeAndSortPsmAudits = (uploadedList = [], digitalList = []) => {
  const uploadedRows = (uploadedList || []).map(normalizeUploadedPsmAudit);
  const digitalRows = (digitalList || [])
    .filter(audit => !isFollowUpAudit(audit))
    .map(audit => ({
      ...normalizeDigitalAuditRow(audit),
      followUp: audit.followUp
        ? {
            ...normalizeDigitalAuditRow(audit.followUp),
            source: 'digital',
            auditType: 'AuditFollowUp',
            auditDate: pickFollowUpAuditDate(audit.followUp),
          }
        : null,
    }));

  return [...uploadedRows, ...digitalRows].sort(compareRowsByAuditDateDesc);
};
